import React from "react";
import { Dropdown } from "react-bootstrap";
import { useSelector } from "react-redux";
import { NavLink } from 'react-router-dom';
import { RootState } from "../redux/store";

const CpntHeaderFODropDownOptions: React.FC = () => {
    const compte = useSelector((state: RootState) => state.compte);

  return (
    <>
        <Dropdown.Item as={NavLink} to="/accueil">
            <i className="bi-house pe-2" />Accueil
        </Dropdown.Item> 
        <Dropdown.Item as={NavLink} to="/moncompte">
            <i className="bi-person-circle pe-2" />Mon Compte
        </Dropdown.Item>
        {(compte && compte.IdTypeCompte === 2) &&
            <Dropdown.Item as={NavLink} to="/mesutilisateurs">
            <i className="bi-people pe-2" />Mes Utilisateurs
            </Dropdown.Item>
        }
        <Dropdown.Item as={NavLink} to="/monorganisation">
            <i className="bi-buildings pe-2" />Mon Organisation
        </Dropdown.Item>
        {/* <Dropdown.Item as={NavLink} to="/messervices">
            <i className="bi-boxes pe-2" />Mes Services
        </Dropdown.Item> */}
    </>
  );
};

export default CpntHeaderFODropDownOptions;
